// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"dm-z","badgeLink":"em-z","category":"fm-z"};